<!--
  StickyControlBar
  ---
  Implementation of StickySlot, see that or StickySlotDemo for details.
  A StickySlot styled as a controls bar, which expands to fill width when docked.
-->

<template>
  <sticky-slot :on-docked="expandBar">
    <div class="controls-container">
      <div ref="controls" class="controls">
        <slot />
      </div>
    </div>
  </sticky-slot>
</template>

<script>
import StickySlot from 'VueComponents/StickySlot';

export default {
  components: {
    StickySlot,
  },
  props: {
    dockedWidth: {
      type: String,
      required: false,
      default: '100%',
    },
    stuckWidth: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  methods: {
    expandBar({ event }) {
      const controls = this.$refs['controls'];
      if (event.isIntersecting) {
        controls.style.width = this.dockedWidth;
      } else {
        controls.style.width = this.stuckWidth;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @use "sass:color";
  @use "sass:map";

  @use '~AssetsSass/_variables' as *;

  .controls-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .controls {
      padding: 1em 2.5em;
      background-color: #ffffff;
      border: 1px solid color.adjust(map.get($ss-adds, 'light-grey'), $lightness: -5%, $space: hsl);
      margin-bottom: 20px;
      border-left: 4px solid map.get($ss, 'secondary');
      border-radius: 3px;

      display: flex;
      gap: 0.6em;

      :deep(.btn) {
        height: 3em;
        font-size: 1.1em;
      }

      // align last btn right
      :deep(.btn:first-child) {
        margin-right: auto;
      }
    }
  }

</style>
